<template>
  <ul :class="$style.container">
    <li
      v-for="(item, index) in items"
      :class="[[$style.item], { [$style.isSelected]: isSelected(index) }]"
      :key="index"
      @click="onSelect(index)"
    >
      {{ item.option_menu }}
    </li>
  </ul>
</template>

<script>
export default {
  name: 'OptionMenu',

  props: {
    items: {
      type: Array,
      required: true,
    },
    selectedOption: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    isSelected(index) {
      return this.selectedOption === index
    },
    onSelect(index) {
      if (index === this.selectedOption) return
      this.$emit('onSelect', index)
    },
  },
}
</script>

<style lang="scss" module>
.container {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.item {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 250px;
  height: 120px;
  margin: 10px;
  border: 2px solid #eae9e3;
  border-radius: 8px;

  font-size: 20px;

  cursor: pointer;
}
.isSelected {
  border-color: #2d50e6;

  box-shadow: 0 0 0 4px #d6e3fd;
}
</style>
